import * as THREE from 'three';
import { TrackballControls } from 'three/examples/jsm/controls/TrackballControls.js';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js';
import { loadTerrain } from './terrain.js';
import typefaceData from "@compai/font-recursive/data/typefaces/normal-400.json";


const apiKey = '7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2',
    wcsApiVer = 'v2',
    baseUrl = `https://avoin-karttakuva.maanmittauslaitos.fi/ortokuvat-ja-korkeusmallit/wcs/${wcsApiVer}?api-key=${apiKey}&`,
    wmsBaseUrl = `https://avoin-karttakuva.maanmittauslaitos.fi/ortokuvat-ja-korkeusmallit/wms/${wcsApiVer}?api-key=${apiKey}&`;


var width = window.innerWidth,
    height = window.innerHeight,
    searchParams = new URLSearchParams(document.location.search.slice(1)),
    addtexture = searchParams.get('texture') === 'true',
    subsetArgs = searchParams.getAll("SUBSET"),
    subsets = {};

const color = new THREE.Color(0xffffff);
const font = new FontLoader().parse(typefaceData);
const matLite = new THREE.MeshBasicMaterial({
    color: color,
    transparent: true,
    opacity: 0.9,
    side: THREE.DoubleSide
});
const matDark = new THREE.MeshBasicMaterial({
    color: color,
    side: THREE.DoubleSide
});

function textMesh(message, pos, q, align, sz) {
    const shapes = font.generateShapes(message, sz || 4);
    const geometry = new THREE.ShapeGeometry(shapes);
    geometry.computeBoundingBox();
    const xMid = - 0.5 * (geometry.boundingBox.max.x - geometry.boundingBox.min.x);
    const xLeft = -(geometry.boundingBox.max.x - geometry.boundingBox.min.x);
    const xTop = -(geometry.boundingBox.max.y - geometry.boundingBox.min.y);
    switch (align) {
        case "top":
            geometry.translate(0, xTop, 0);
            break;
        case "left":
            geometry.translate(xLeft, 0, 0);
            break;
        case "center":
            geometry.translate(xMid, 0, 0);
            break;
    }

    const text = new THREE.Mesh(geometry, matLite);
    text.position.x = pos.x;
    text.position.y = pos.y;
    text.position.z = pos.z;
    text.setRotationFromQuaternion(q)
    return text;
}

function sceneTextMesh(scene, message, x, y, z, align) {
    const textpos = new THREE.Vector3(x, y, z);
    const textq = new THREE.Quaternion(1, 0, 0, Math.PI / 2);
    var text = textMesh(message, textpos, textq, align);
    scene.add(text);

}
function sceneTextMeshQ(scene, message, x, y, z, align,textq) {
    const textpos = new THREE.Vector3(x, y, z);
    var text = textMesh(message, textpos, textq, align);
    scene.add(text);

}

function formatNum(num){
    return (Math.round(num * 100) / 100).toFixed(2);    
}

var coverageId = searchParams.get('CoverageID');

subsetArgs.forEach(function (v, i) {
    var spec = /(.*)\((.*),(.*)\)/.exec(v);
    console.log(spec);
    subsets[spec[1]] = [Number(spec[2]), Number(spec[3])]; // checking
});

var w = 312,
    exaggeration = Number(searchParams.get("EXAGGERATION") || "1.0"),
    metersE = subsets['E'][1] - subsets['E'][0],
    metersN = subsets['N'][1] - subsets['N'][0],
    reso = metersE / w,
    heightMultiplier = (1 / reso),
    xagg = exaggeration * heightMultiplier,
    d = parseInt(metersN / metersE * w),
    textureMultiplier = 4
    ;

   
var dataUrl = [baseUrl,
        'service=WCS&version=2.0.1&request=GetCoverage&CoverageID=korkeusmalli_2m&', 'SUBSET=E(', subsets['E'][0], ',', subsets['E'][1], ')&',
        'SUBSET=N(', subsets['N'][0], ',', subsets['N'][1], ')&',
        'format=text/plain&',
        'SCALESIZE=i(', w, '),j(', d, ')&debug=true'].join(''),
    textureUrl = [
        wmsBaseUrl,
        'FORMAT=image/jpeg&TRANSPARENT=false&LAYERS=' + coverageId + '&REQUEST=GetMap&VERSION=1.3.0&SERVICE=WMS&STYLES=&CRS=EPSG:3067&',
        'WIDTH=', w * textureMultiplier, '&HEIGHT=', d * textureMultiplier,
        '&BBOX=', subsets['E'][0], ',', subsets['N'][0], ',', subsets['E'][1], ',', subsets['N'][1],
        searchParams.get('TIME') ? ('&TIME=' + searchParams.get('TIME')) : ''
    ].join('');

var scene = new THREE.Scene();

/*var axes = new THREE.AxisHelper(200);
scene.add(axes);
*/
var camera = new THREE.PerspectiveCamera(45, width / height, 0.1, 1000);
camera.position.y = -2 * d;
camera.position.z = 100;

var renderer = new THREE.WebGLRenderer();
renderer.setSize(width, height);
//renderer.shadowMapEnabled = true;
//renderer.shadowMapSoft = true;
var geometry;


function texture(textureUrl) {
    var textureLoader = new THREE.TextureLoader();
    var texture1 = textureLoader.load(textureUrl);

    var material = new THREE.MeshPhongMaterial({
        color: 0xffddee,
        map: texture1
        //          wireframe: true
    });

    return material;
}

function start(data) {
    console.log(data);

    geometry = new THREE.PlaneGeometry(w, d, w - 1, d - 1);
    window.geometry = geometry;
    //geometry.computeFaceNormals();
    geometry.computeVertexNormals();

    let pos = geometry.getAttribute('position');
    for (var i = 0; i < w; i++) {
        for (var j = 0; j < d; j++) {
            //ps[j * w + i].z = (data.data[j][i] - data.mid) * xagg;
            pos.setZ(j * w + i, (data.data[j][i] - data.mid) * xagg);
        }
    }

    var material = addtexture ? texture(textureUrl) : new THREE.MeshPhongMaterial({
        color: 0xffddee,
        wireframe: true
    });

    var plane = new THREE.Mesh(geometry, material);
    plane.castShadow = true;
    plane.receiveShadow = true;
    scene.add(plane);

    // scales, extents etc
    const
        zmin = (data.min - data.mid) * xagg,
        zmax = (data.max - data.mid) * xagg,
        ymin = -d / 2, ymax = d / 2,
        xmin = -w / 2, xmax = w / 2;
    const linematerial = new THREE.LineBasicMaterial({ color: 0xffffff });

    // back to right
    const linepoints = [];
    linepoints.push(new THREE.Vector3(xmin, ymax, zmax));
    linepoints.push(new THREE.Vector3(0, ymax, zmax));
    linepoints.push(new THREE.Vector3(xmax, ymax, zmax));
    linepoints.push(new THREE.Vector3(xmax, ymin, zmax));
    linepoints.push(new THREE.Vector3(xmax, ymin, zmin));
    linepoints.push(new THREE.Vector3(xmin, ymin, zmin));
    linepoints.push(new THREE.Vector3(xmin, ymin, zmax));
    linepoints.push(new THREE.Vector3(xmin, ymax, zmax));

    // https://github.com/mrdoob/three.js/tree/dev/examples/fonts
    // https://github.com/components-ai/typefaces


    sceneTextMesh(scene, `${formatNum(data.max)}m`, xmax+2, ymin, zmax);
    sceneTextMesh(scene, `${formatNum(data.min)}m`, xmax+2, ymin, zmin);

    sceneTextMesh(scene, `${formatNum(subsets['E'][0])}, ${formatNum(subsets['N'][0])}`, xmin-2, ymin, zmin, 'left');
    sceneTextMesh(scene, `${formatNum(subsets['E'][1])}, ${formatNum(subsets['N'][1])}`, xmax+2, ymax, zmax);

    sceneTextMesh(scene, `<- ${formatNum(metersE)}m ->`, xmin+(xmax-xmin)/2, ymin, zmin-2,'top');
    sceneTextMesh(scene, `<- ${formatNum(metersN)}m ->`, xmin-2, ymin+(ymax-ymin)/2, zmax, 'left');


    const extent = new THREE.BufferGeometry().setFromPoints(linepoints);
    const line = new THREE.Line(extent, linematerial);
    scene.add(line);



    document.getElementById('webgl').appendChild(renderer.domElement);

    if (addtexture)
        scene.add(new THREE.AmbientLight(0xffffff));
    else
        scene.add(new THREE.AmbientLight(0xff8080));

    var light = new THREE.DirectionalLight(0xffffff, 1);
    //        light.shadowCameraVisible = true;
    light.position.set(0, 300, 100);
    scene.add(light);

    var controls = new TrackballControls(camera, renderer.domElement);
    render();

    function render() {
        controls.update();
        requestAnimationFrame(render);
        renderer.render(scene, camera);
    }

}


loadTerrain(dataUrl, start);



